import React, { useState, useEffect} from 'react';

import Label from '../../../Components/Label';
import InputField from '../../../Components/InputField';
import Button from '../../../Components/Button';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import { toast } from 'react-toastify';

import '../../../Assets/css/toast.css';

const UnitUserProfile = () => {
    const token = localStorage.getItem('unittoken');
    const decodedToken = jwtDecode(token);
    const userId ={userID: decodedToken.id};

    //---------Reset password---------------
    const [resetPasswordOpen, setResetPasswordOpen] = useState(false);

    const [userProfileData, setUserProfileData] = useState({});
    const [userPassword, setUserPassword] = useState({token:token});

    const regex1 = /^(?!_)[a-zA-Z0-9_]{2,10}$/;//Contains 2-10 numbers, letters, underlines, but not starts with underline
    const [error, setError] = useState("");
    useEffect(() => {
        const fetch = async () => {
            const POCBaseUrl = process.env.REACT_APP_GXIN_POC_BASE_URL;

            if (!POCBaseUrl) {
                throw new Error('API base URL is not defined');
            }
            await axios.post(`${POCBaseUrl}/unitprofiles/unitget`, {userId},
                {
                    headers: {
                      "Content-Type": "application/json", // Specify content type
                      Authorization: `Bearer ${token}`, // Include the token
                    },
                  }
            )
            .then(response => {
                // console.log('response',response.data, response.data.data.name);
                setUserProfileData(response.data.data);
            })
            .catch(error => {
                console.error("There was an error fetching the customer data!", error);
            });
        }
        fetch();
    }, []);

    const handleProfileChange = (e) => {
        setUserProfileData({
            ...userProfileData,
            [e.target.name]: e.target.value,
        });
    };

    const handlePasswordChange = (e) => {
        setUserPassword({
            ...userPassword,
            [e.target.name]: e.target.value,
        });
    };

    const [resetPasswordOk, setResetPasswordOk] = useState(false);

    const handleProfileUpdate = async(e) => {
        e.preventDefault();
        try {
            const POCBaseUrl = process.env.REACT_APP_GXIN_POC_BASE_URL;

            if (!POCBaseUrl) {
                throw new Error('API base URL is not defined');
            }
            if(!resetPasswordOk) {
                setUserPassword({});
            }
        if (regex1.test(userProfileData.contacts)) {
            setError("");
            } else {
            toast.warn("Contains 2-10 numbers, letters, underlines, but not starts with underline", {
                className: 'centered-toast1',
                bodyClassName: 'centered-body',
                autoClose: 2000,
                hideProgressBar: true,
                closeButton: false,
                pauseOnHover: false,
                draggable: true,
                });
            return;
            }
            const response = await axios.post(`${POCBaseUrl}/unitprofiles/unitupdate`, {userId,userProfileData,userPassword},
                {
                    headers: {
                      "Content-Type": "application/json", // Specify content type
                      Authorization: `Bearer ${token}`, // Include the token
                    },
                  }
            )
            .then(response=>{
                // console.log(response.data.message);
                toast.success('profile updated successfully!', {
                    className: 'centered-toast-success',
                    bodyClassName: 'centered-body',
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeButton: false,
                    pauseOnHover: false,
                    // draggable: true,
                    pauseOnFocusLoss: true
                  });
            })
            .catch(error=>{
                console.error("There was an error", error);
            })
        } catch (error) {
            console.error('Error sending message:', error);
        }

    };
    const handleResetPassword = async(e) => {

        setResetPasswordOpen(false);
        setResetPasswordOk(true);

        e.preventDefault();
        try {
            const POCBaseUrl = process.env.REACT_APP_GXIN_POC_BASE_URL;

            if (!POCBaseUrl) {
                throw new Error('API base URL is not defined');
            }
            if(!resetPasswordOk) {
                setUserPassword({});
            }

            const response = await axios.post(`${POCBaseUrl}/unitprofiles/unitresetpassword`, {userId,userPassword},
                {
                    headers: {
                      "Content-Type": "application/json", // Specify content type
                      Authorization: `Bearer ${token}`, // Include the token
                    },
                  }
            )
            .then(response=>{
                console.log(response.data.message);
            })
            .catch(error=>{
                console.error("There was an error", error);
            })
        } catch (error) {
            console.error('Error sending message:', error);
        }

    };

    return (
        <>
            <div className="flex mt-2.5 bg-[#f0f0f0] rounded-[5px]">
                <div className="ml-[25px] mt-2.5 pr-[40px]">
                    <div className='mb-[22px] flex'>
                        <Label text={'Company_name'} />
                        <div className='relative text-[14px] leading-[40px] '>
                            <InputField name = {'name'} value={userProfileData.company_name || ''} onChange={handleProfileChange} placeholder={'Alertline'} className={'cursor-not-allowed !text-[#5a5655]'} disabled={true}/>
                        </div>
                    </div>
                    <div className='mb-[22px] flex'>
                        <Label text={'Contacts'} />
                        <div className='relative text-[14px] leading-[40px]'>
                            <InputField name = {'contacts'} value={userProfileData.contacts || ''} onChange={handleProfileChange} placeholder={''}/>
                        </div>
                        <div>
                        </div>
                        <span className='h-[24px] mt-[10px] text-[#fc3b3e] ml-[10px] text-[14px]'>Contains 2-10 numbers, letters, underlines, but not starts with underline</span>
                    </div>
                    <div className='mb-[22px] flex'>
                        <Label text={'Phone Number'} />
                        <div className='relative text-[14px] leading-[40px]'>
                            <InputField name = {'phone_number'} value={userProfileData.phone_number || ''} onChange={handleProfileChange} placeholder={''} />
                        </div>
                    </div>
                    <div className='mb-[22px] flex'>
                        <Label text={'Account'} />
                        <div className='relative text-[14px] leading-[40px]'>
                            <InputField name = {'account'} value={userProfileData.account || ''} placeholder={'Alertline123'} className={'cursor-not-allowed !text-[#5a5655]'} disabled={true}/>
                        </div>
                    </div>
                    <div className='mb-[22px] flex'>
                        <Label text={'Login password'} />
                        <div className='relative text-[14px] leading-[40px] !w-[272px]'>
                            <InputField type={'password'} placeholder={'******'} className='!w-[272px]' />
                        </div>
                        <div>
                            <Button children={'Reset'} onClick={()=> setResetPasswordOpen(true)}/>
                        </div>
                        <span className='h-[24px] mt-[10px] text-[#fc3b3e] ml-[10px] text-[14px]'>Constains 6-16 letters or numbers</span>
                    </div>
                </div>
            </div>
            <div className='mt-2.5 bg-[#f0f0f0]'>
                <button onClick={handleProfileUpdate} className='inline-block mt-2.5 mb-2.5 ml-44 bg-[#2776c3] py-2 px-24 rounded text-white cursor-pointer'>
                    Update
                </button>
            </div>
            {resetPasswordOpen && (
                <div className="fixed inset-0 p-4 flex flex-wrap justify-center items-center w-full h-full z-[1000] before:fixed before:inset-0 before:w-full before:h-full before:bg-[rgba(0,0,0,0.5)] overflow-auto font-[sans-serif]" style={{ fontFamily: 'Liberation Serif' }}>
                    <div className="w-[600px] bg-white shadow-lg rounded-lg p-6 relative">
                        <div className="flex items-center pb-3 border-b border-gray-300">
                            <h3 className="text-xl flex-1 text-center text-[#2776c3]">Reset login password</h3>
                            <svg
                                className="w-3 ml-2 cursor-pointer shrink-0 fill-gray-400 hover:fill-red-500"
                                viewBox="0 0 320.591 320.591"
                                onClick={()=> setResetPasswordOpen(false)} // Close modal on click
                            >
                                <path
                                    d="M30.391 318.583a30.37 30.37 0 0 1-21.56-7.288c-11.774-11.844-11.774-30.973 0-42.817L266.643 10.665c12.246-11.459 31.462-10.822 42.921 1.424 10.362 11.074 10.966 28.095 1.414 39.875L51.647 311.295a30.366 30.366 0 0 1-21.256 7.288z"
                                />
                                <path
                                    d="M287.9 318.583a30.37 30.37 0 0 1-21.257-8.806L8.83 51.963C-2.078 39.225-.595 20.055 12.143 9.146c11.369-9.736 28.136-9.736 39.504 0l259.331 257.813c12.243 11.462 12.876 30.679 1.414 42.922-.456.487-.927.958-1.414 1.414a30.368 30.368 0 0 1-23.078 7.288z"
                                />
                            </svg>
                        </div>
        
                        <div className="pt-5 flex justify-center items-center">
                            <span className='text-[#5a5655]'>Initial password:</span>
                            <InputField name = {'oldPassword'} value={userPassword.oldPassword || ''} onChange={handlePasswordChange} type={'password'} placeholder={'Please enter the previous password'} />
                        </div>
                        <div className="pt-5 flex justify-center items-center">
                            <span className='text-[#5a5655]'>New password:</span>
                            <InputField name = {'newPassword'} value={userPassword.newPassword || ''} onChange={handlePasswordChange} type={'password'} placeholder={'Please enter the new password (6-16 characters)'} />
                        </div>
                        <div className="pt-5 flex justify-center items-center">
                            <span className='text-[#5a5655]'>Confirm password:</span>
                            <InputField name = {'confirmPassword'} value={userPassword.confirmPassword || ''} onChange={handlePasswordChange} type={'password'} placeholder={'Please confirm the new password (6-16 characters)'} />
                        </div>
        
                        <div className="pt-10 flex justify-center gap-4" style={{ fontFamily: 'Liberation Serif' }}>
                            <button
                                type="button"
                                className="w-[320px] h-[36px] rounded-lg text-[white] text-sm border-none outline-none tracking-wide bg-[#2776c3]"
                                onClick={handleResetPassword} // Close modal on click
                            >
                                Yes
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default UnitUserProfile;